import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { focusOutline } from '@design-system/theme';
import { DefaultLink } from './DefaultLink';
import { LinkSimple } from './LinkSimple';
import { getLinkStyle, ignoredPropsConfig } from '../style';
import { useGetRoutingType } from '../utils/getRoutingType';
let NextLinkComponent = null;
try {
    const { NextLink } = require('./NextLink');
    NextLinkComponent = NextLink;
}
catch (_a) {
}
const LinkWrapper = styled(LinkSimple).withConfig(ignoredPropsConfig) `
  ${getLinkStyle};
  ${focusOutline};
`;
export const Link = (_a) => {
    var { children, enableWrap = false, forceDefaultLink, styledOnlyOnHover = false, to } = _a, otherProps = __rest(_a, ["children", "enableWrap", "forceDefaultLink", "styledOnlyOnHover", "to"]);
    const routingType = useGetRoutingType();
    if (forceDefaultLink || routingType === 'html') {
        return (_jsx(DefaultLink, Object.assign({}, otherProps, { enableWrap: enableWrap, href: typeof to === 'string' ? to : undefined, styledOnlyOnHover: styledOnlyOnHover, children: children })));
    }
    if (routingType === 'nextjs' && NextLinkComponent) {
        return (_jsx(NextLinkComponent, Object.assign({ enableWrap: enableWrap, href: typeof to === 'string' ? to : '', styledOnlyOnHover: styledOnlyOnHover }, otherProps, { children: children })));
    }
    return (_jsx(LinkWrapper, Object.assign({ enableWrap: enableWrap, styledOnlyOnHover: styledOnlyOnHover, to: to }, otherProps, { children: children })));
};
//# sourceMappingURL=Link.js.map